// Uploading/searching your own transactions is available to FREE and SUBSCRIBER plans;
// TRIAL is excluded. Treat an unknown/missing plan as ineligible rather than assuming access —
// the backend enforces this regardless, so a false positive here would just be a confusing dead end.
export const canUseOwnTransactions = (subscriptionPlan) => Boolean(subscriptionPlan) && subscriptionPlan !== 'TRIAL';
